<div class="wrapper">
  <div class="cooking-story-header">
    <img
      src="assets/cookingbook/angle-white.svg"
      (click)="goBack()"
      class="goback icon-shadow"
      alt=""
    />
    <p class="title">افراد خانه</p>
    <img
      class="icon"
      src="assets/cookingbook/more-white.svg"
      (click)="leave()"
      *ngIf="!isOwner && isReady"
      alt=""
    />
    <div *ngIf="!isReady">
      <ngx-skeleton-loader
        animation="pulse"
        class="icon"
        [theme]="{
          width: '32px',
          height: '32px',
          'border-radius': '12px',
          'backgrund-color': '#eceef0'
        }"
      ></ngx-skeleton-loader>
    </div>
  </div>
  <div class="cooking-story-body">
    <div>
      <p class="members-title" *ngIf="membersLength > 1 && isReady">
        {{ membersLength }} نفر در این خانه هستند،<br />
        سبد خرید و آشپزخانه شما با افراد این لیست مشترک است
      </p>
      <ngx-skeleton-loader
        animation="pulse"
        *ngIf="!isReady"
        [theme]="{
          height: '32px',
          width: '100%',
          'border-radius': '12px',
          'backgrund-color': '#eceef0'
        }"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        animation="pulse"
        *ngIf="!isReady"
        [theme]="{
          height: '32px',
          width: '60%',
          'border-radius': '12px',
          'backgrund-color': '#eceef0'
        }"
      ></ngx-skeleton-loader>
      <div *ngIf="!isReady">
        <ngx-skeleton-loader
          animation="pulse"
          *ngFor="let i of garr(5)"
          [theme]="{
            height: '72px',
            width: '100%',
            'border-radius': '12px',
            'backgrund-color': '#666'
          }"
        ></ngx-skeleton-loader>
      </div>
      <div *ngIf="isReady">
        <ng-container>
          <div class="member">
            <img
              class="profile"
              [src]="getProfile(home?.owner)"
              [ngClass]="{ active: isMe(home?.owner._id) }"
              alt=""
            />
            <div>
              <p>
                {{ home?.owner.name }}

                <span *ngIf="isMe(home?.owner._id)"> (من)</span>
              </p>
              <span class="admin">مدیر خانه</span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngFor="let member of home.members">
          <div class="member" (click)="editUser(member.user)">
            <img
              class="profile"
              [src]="getProfile(member.user)"
              [ngClass]="{ active: isMe(member.user._id) }"
              alt=""
            />
            <div>
              <p>
                {{ member.user.name }}
                <span *ngIf="isMe(member.user._id)"> (من)</span>
              </p>
            </div>
            <img
              class="angle"
              *ngIf="isOwner"
              src="assets/cookingbook/angle_left_blue.svg"
              alt=""
            />
          </div>
        </ng-container>
        <div *ngIf="home.members.length == 0" class="hint">
          <img class="main" src="assets/cookingbook/members.svg" alt="" />
          <p>برای اضافه کردن افراد دیگر به خانه، از این دکمه استفاده کنید.</p>
          <img class="pointer" src="assets/cookingbook/arrow-down.svg" alt="" />
        </div>
      </div>
      <ngx-skeleton-loader
        *ngIf="!isReady"
        animation="pulse"
        class="button-loading"
        [theme]="{
          'backgrund-color': '#eceef0 !important',
          height: '56px',
          'border-radius': '24px',
          width: 'calc(calc(100vw / 2 ) - 48px)',
          position: 'fixed',
          bottom: '24px',
          right: '24px'
        }"
      ></ngx-skeleton-loader>

      <div
        class="button"
        *ngIf="isOwner && isReady && !showTutorial"
        (click)="openShare()"
      >
        <img src="assets/cookingbook/forward.svg" alt="" />
        افزودن اعضا
      </div>
    </div>
  </div>
</div>
<app-cooking-story-success-message></app-cooking-story-success-message>
<app-cooking-story-tutorial-kitchen
  [type]="'members'"
  *ngIf="showTutorial"
></app-cooking-story-tutorial-kitchen>
